import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

// Interfaces locais para evitar problemas de importação
interface VehicleRental {
  id: number;
  rentalNumber: string;
  startDate: string;
  endDate: string;
  priority: string;
  status: string;
  customerName?: string;
  driverName?: string;
}

@Component({
  selector: 'app-vehicle-rental-approval',
  templateUrl: './vehicle-rental-approval.component.html',
  styleUrls: ['./vehicle-rental-approval.component.css']
})
export class VehicleRentalApprovalComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  rentalId: number | null = null;
  vehicleRental: VehicleRental | null = null;
  approvalForm!: FormGroup;
  isLoading = true;
  isSubmitting = false;

  // Dados mock para demonstração
  mockRental: VehicleRental = {
    id: 1,
    rentalNumber: 'LOC-20240918-001',
    startDate: '2024-09-20',
    endDate: '2024-09-25',
    priority: 'NORMAL',
    status: 'PENDENTE',
    customerName: 'João Silva',
    driverName: 'João Silva',
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder
  ) {
    this.initializeForm();
  }

  ngOnInit(): void {
    this.route.params.pipe(takeUntil(this.destroy$)).subscribe(params => {
      if (params['id']) {
        this.rentalId = +params['id'];
        this.loadRental();
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private initializeForm(): void {
    this.approvalForm = this.fb.group({
      action: ['approve', Validators.required],
      comments: ['', [Validators.maxLength(500)]],
      approvalLevel: [''],
      conditions: ['']
    });
  }

  private loadRental(): void {
    // Simulação de carregamento
    setTimeout(() => {
      this.vehicleRental = this.mockRental;
      this.isLoading = false;
    }, 1000);
  }

  onSubmit(): void {
    if (this.approvalForm.valid) {
      this.isSubmitting = true;

      // Simular processamento da aprovação
      setTimeout(() => {
        const action = this.approvalForm.value.action;
        const message = action === 'approve'
          ? 'Locação aprovada com sucesso!'
          : 'Locação rejeitada.';

        alert(message);
        this.isSubmitting = false;
        this.router.navigate(['/commercial/vehicle-rentals', this.rentalId]);
      }, 2000);
    } else {
      this.approvalForm.markAllAsTouched();
    }
  }

  cancel(): void {
    this.router.navigate(['/commercial/vehicle-rentals', this.rentalId]);
  }

  formatDate(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR');
  }

  formatCurrency(value: number): string {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  }

  getStatusClass(status: string): string {
    switch (status.toLowerCase()) {
      case 'pendente': return 'badge bg-warning';
      case 'ativa': return 'badge bg-success';
      case 'finalizada': return 'badge bg-info';
      case 'cancelada': return 'badge bg-danger';
      default: return 'badge bg-secondary';
    }
  }
}
